<template>
  <one-column-layout :loading="!loaded">

    <title-bar :title="title" slot="titleBar">
      <div class="smd-spacer"/>

      <smd-btn icon="smd-icon-action-close" @click="close"/>
    </title-bar>

    <two-column-layout class="sb-min-180 hide-sidebar">
      <title-bar class="space-s-l" type="page" slot="sidebar">
        <smd-btn clean class="icon-text" @click="back">
          <i class="smd-icon-arrow-left"/>
          <label dark-normal>Back</label>
        </smd-btn>
      </title-bar>



        <one-column-layout class="space-l max-1000 flex-start" slot="content">
          <title-bar title="Case Information" type="page" slot="titleBar">
            <div class="smd-spacer"/>
            <smd-btn @click.prevent="savePatientInfo">Save</smd-btn>
          </title-bar>

          <div class="form">
            <div>
              <div class="form__row--x">
                <label>Case Number</label>
                <input type="text" placeholder="e.g. CASE1234" v-model="patientcase.caseNum">
              </div>
              <div class="form__row--x">
                <label>Date of Birth</label>
                <smd-date-input v-model="patientcase.birthDate" hide-picker/>
              </div>
              <div class="form__row--x" v-if="isPediatric">
                <label>Confirm that patient is {{computeAge}} years of age and considered a pediatric case?</label>
                <smd-segment type="pill"
                             v-model="confirmPediatric"
                             :items="$options.booleanChoices"/>
              </div>
            </div>
          </div>
        </one-column-layout>

    </two-column-layout>

  </one-column-layout>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex'
  import Moment from 'moment'
  import { MUTATE_SHOW_OVERLAY } from '../../../store/modules/shared'
  import {
    GETTER_SELECTED_PATIENT_CASE,
    ACTION_ADD_PATIENT_CASE,
    ACTION_SAVE_PATIENT_CASE,
    ACTION_LOAD_PATIENT_CASE_INFO
  } from '../../../store/modules/patients'
  import Routes from '../../../router/route-constants'

  export default {
    data(){
      return{
        loaded: false,
        patientcase: {
          _id        : null,
          caseNum    : null,
          birthDate  : null
        },
        confirmPediatric: false
      }
    },
    computed: {
      ...mapGetters({
        selectedPatient: GETTER_SELECTED_PATIENT_CASE
      }),
      isNew() {
        return this.$route.name === Routes.ROUTE_NEW_PATIENT_CASE_INFO
      },
      title(){
        return this.isNew ? "New Case" : "Edit Case"
      },
      computeAge() {
        return this.patientcase.birthDate ? this.getAge(this.patientcase.birthDate, new Date()) : 100
      },
      isPediatric() {
        return this.computeAge < 19
      }
    },
    methods:{
      ...mapMutations({
        showOverlay: MUTATE_SHOW_OVERLAY
      }),
      ...mapActions({
        addPatientCase : ACTION_ADD_PATIENT_CASE,
        editPatientCase: ACTION_SAVE_PATIENT_CASE
      }),
      getAge(date, fromDate) {
        let today = fromDate;
        let birthDate = new Date(date);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
        {
          age--;
        }
        return age;
      },
      savePatientInfo(){

        if (this.isPediatric && !this.confirmPediatric) { this.$toasted.show("Please confirm that patient is a pediatric case."); return; }
        // Check if valid
        if (!this.patientcase.caseNum) { this.$toasted.show("Case number is required"); return; }

        let data = {
          caseid    : this.patientcase._id,
          caseNum   : this.patientcase.caseNum,
          birthDate : this.patientcase.birthDate
        };

        let promise = this.isNew ? this.addPatientCase(data) : this.editPatientCase(data)
        promise.then(this.afterSavePatientCaseInfo(this.isNew))
          .catch((err) => {
            this.$toasted.show(err.message);
          });


      },
      afterSavePatientCaseInfo(isNew) {
        return (data) => {
          this.displayToast();
          if (isNew) {
            this.$router.push({name: Routes.ROUTE_NEW_PATIENT_CASE, params: { patientid: data._id }});
          } else {
            this.$router.push({name: Routes.ROOT_ROUTE_CASES});
          }
        }
      },
      back(){
        this.showOverlay(true);
        this.$router.push({name: Routes.ROOT_ROUTE_CASES});
      },
      close(){
        this.showOverlay(false);
        this.$router.push({name: Routes.ROOT_ROUTE_CASES});
      },
      init(caseid) {
        if (!this.isNew) {
          this.$store.dispatch(ACTION_LOAD_PATIENT_CASE_INFO, caseid).then( () => {
            this.patientcase = this.selectedPatientCase.info;
            this.loaded = true;
          })
        } else {
          this.loaded = true
        }
      },
      displayToast(){
        const message = this.isNew ?
          'Successfully added new patient case!' :
          'Successfully updated patient case information!';
        this.$toasted.show(message);
      }
    },
    beforeRouteEnter(to,from,next) {
      next(vm => {
        vm.init(to.params.caseid)
      })
    },
    booleanChoices: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ]
  }
</script>

<style lang="scss">

  @import "../../../scaffolding/scss/pogs-util";

  .form.new-patient{
    @include make-grid-cols(150px 1fr, space(m));

    & > div:first-child{
      @extend %flex-col, %align-items-center;
    }

    .form__row--x{
      max-width: 80%;
    }
  }

</style>
